import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { getDocuments } from '../api/documentsApi'
import { Document } from '../types'

export default function useDocuments(options?: SWRConfiguration) {
  return useSWR<Document[], Error>('documents', getDocuments, options)
}
